import { useContext } from 'react';
import { ModalContext } from './ModalContext';
import { ConfirmCreator } from './useModalCreator';

export function useConfirm(): ConfirmCreator {
  const { confirm } = useContext(ModalContext);
  if (confirm) {
    return confirm;
  } else {
    throw new Error('useConfirm must be used within a ModalProvider');
  }
}
